<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoInserir">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoInserir">
			<form (keypress)="ocultarMensagem()" (ngSubmit)="f.form.valid && salvar()" #f="ngForm" name="form"
				novalidate>
				<div class="formgroup">
					<div class="p-fluid p-formgrid grid">
						<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
						</div>

						<div class="field col-12 md:col-5">
							<label htmlFor="descricao">Descrição</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								placeholder="Descrição do Fabricante" name="descricao" ngModel #nome="ngModel"
								required />
							<div *ngIf="nome.hasError('required') && nome.touched" class="alerta">
								<small>Campo obrigatório</small>
							</div>
						</div>

						<div class="field col-12 md:col-3">
							<label htmlFor="cnpj">CNPJ</label>
							<p-inputMask mask="99.999.999/9999-99" [unmask]="true" type="text"
								placeholder="00.000.000/0000-00" name="cnpj" ngModel #cnpj="ngModel"
								(onBlur)="buscarFabricante()"> </p-inputMask>
							<div *ngIf="fabricanteEncontrado" class="alerta">
								<small>Fabricante já cadastrado para essa empresa</small>
							</div>
						</div>

					</div>
					<div class="p-fluid p-formgrid grid justify-content-between">
						<div class="col-12 md:col-4" >
							<button *ngIf="!progressoRequisicao else exibirBotaoFalso"
								type="submit" pButton icon="pi pi-check" label="Salvar"
								class="p-button-outlined p-button-success md:w-9rem" [disabled]="!f.valid || fabricanteEncontrado">
							</button>
							<ng-template #exibirBotaoFalso>
								<button type="submit" pButton icon="pi pi-spin pi-spinner" label="Salvar"
								class="p-button-outlined p-button-success md:w-9rem" disabled></button>
							</ng-template>
						</div>
						<div class="col-12 md:col-4 flex justify-content-end">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem" routerLink="/apps/fabricante"></button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>